<template>
  <div>
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <div class="row">
          <div class="col-12">
            <section-title
              icon="fa fa-clipboard-list-check"
              title="Resumen de Información General"
              title-class="font-14"
              class="mt-4"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <detail-general-info-panel
              content="Total de Child Count"
              :count="summary.totalChildCount"
              :has-badge="false"
              image="eden-egreso-total.svg"
            />
          </div>
          <div class="col-md-12">
            <detail-general-info-panel
              content="Diferencia Año Anterior"
              :count="summary.lastYearDifferenceCount"
              :has-badge="true"
              :badge-percent="computePercentage"
              image="eden-egreso-dif-anio-anterior.svg"
            />
          </div>
        </div>
      </div>
      <div class="col-md-8 col-sm-12">
        <div class="row">
          <div class="col-12">
            <section-title
              icon="fa fa-clipboard-list-check"
              title="Exclusiones"
              title-class="font-14"
              class="mt-4"
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-6 col-sm-12">
            <alert-detail
              content="Estudiante no cuenta con impedimento en sistema."
              :count="errorValidation.doesNotHaveDisabilityCount"
              :percentage="errorValidation.doesNotHaveDisabilityPercentage"
              :has-button="true"
              button-text="Descargar Detalle"
              button-container-class="mt-2 execute-button"
              @click="
                onGetAlertDetailReportHandler(
                  edenDataValidationErrorTypeEnum.StudentDoesNotHaveDisability
                )
              "
            />
          </div>
          <div class="col-md-6">
            <alert-detail
              content="Hogar, Head Start o Centro de Cuido mayor de 6 años y sin referido activo con corporación."
              :count="
                errorValidation.doesNotHaveActiveReferralWithCorporationCount
              "
              :percentage="
                errorValidation.doesNotHaveActiveReferralWithCorporationPercentage
              "
              :has-button="true"
              button-text="Descargar Detalle"
              button-container-class="mt-2 execute-button"
              @click="
                onGetAlertDetailReportHandler(
                  edenDataValidationErrorTypeEnum.StudentDoesNotHaveActiveReferralWithCorporation
                )
              "
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <summary-by-category :summary="summary.detail"></summary-by-category>
      </div>
    </div>

    <detail-snapshot
      title="Detalle de Child Count"
      :filter-manager-config="filterManagerConfig"
      :filters="filters"
      :data="resultData"
      :paging-list="pagingList"
      :page-size="pageSize"
      :page-size-mobile="pageSizeMobile"
      @on-search="onHandlerSearch"
      @on-change-page="goToPageHandler($event)"
      @on-selected-paging="onSelectedPagingHandler($event)"
      @on-print="
        {
        }
      "
    >
      <div
        v-for="(row, idx) of resultData.result"
        :key="`result-${idx}`"
        class="py-1"
      >
        <component
          :is="resultRow_component"
          :data="row"
          class="mb-3"
        ></component>
      </div>
    </detail-snapshot>
  </div>
</template>

<script>
import DetailGeneralInfoPanel from "@/views/eden/shared/components/DetailGeneralInfoPanel.vue";
import DetailSnapshot from "../../shared/components/DetailSnapshot.vue";
import SectionTitle from "SectionTitle";
import ResultRowDetail from "./ResultRowDetail.vue";
import SummaryByCategory from "./SummaryByCategory.vue";
import AlertDetail from "./AlertDetail.vue";

import DocumentServices from "@/modules/report/document";
import ReportServices from "@/modules/report/api";
import Service from "@/services/api/edenchildcount.api";

import edenDataValidationErrorType from "@/utils/constants/edenDataValidationErrorType.js";

export default {
  name: "ReportDetail",
  components: {
    DetailGeneralInfoPanel,
    DetailSnapshot,
    SectionTitle,
    ResultRowDetail,
    SummaryByCategory,
    AlertDetail,
  },
  inject: ["mediaQueries"],
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    collections: {
      type: Object,
      default: () => ({
        ethnicGroups: [],
        ageGroups: [],
        genders: [],
        impediments: [],
        languagesProficiency: [],
        locationAlternatives: [],
      }),
    },
    summary: {
      type: Object,
      default: () => {},
    },
    errorValidation: {
      type: Object,
      default: () => {},
    },
    edenMasterId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    resultRow_component: "ResultRowDetail",
    filters: {
      ethnicGroup: null,
      ageGroup: null,
      gender: null,
      impediment: null,
      languageProficiency: null,
      locationAlternative: null,
      studentSieId: null,
    },
    resultData: {
      result: {},
      pagination: {},
      selectedPaging: null,
    },
  }),
  computed: {
    pageSize() {
      return 20;
    },
    pageSizeMobile() {
      return 5;
    },
    filterManagerConfig() {
      return [
        {
          name: "ethnicGroup",
          component: "custom-drop-down",
          fieldKey: "id",
          fieldName: "name",
          label: "Grupo Étnico:",
          placeholder: "Seleccione",
          clearable: true,
          class: "col-12 col-md-3",
          options: this.collections.ethnicGroups,
          value: this.filters.ethnicGroup,
          disabled: this.collections.ethnicGroups?.length <= 0,
        },
        {
          name: "ageGroup",
          component: "custom-drop-down",
          fieldKey: "id",
          fieldName: "name",
          label: "Grupo de Edad:",
          placeholder: "Seleccione",
          clearable: true,
          class: "col-12 col-md-3",
          options: this.collections.ageGroups,
          value: this.filters.ageGroup,
          disabled: this.collections.ageGroups?.length <= 0,
        },
        {
          name: "gender",
          component: "custom-drop-down",
          fieldKey: "id",
          fieldName: "name",
          label: "Género:",
          placeholder: "Seleccione",
          clearable: true,
          class: "col-12 col-md-3",
          options: this.collections.genders,
          value: this.filters.gender,
          disabled: this.collections.genders?.length <= 0,
        },
        {
          name: "impediment",
          component: "custom-drop-down",
          fieldKey: "id",
          fieldName: "name",
          label: "Impedimento:",
          placeholder: "Seleccione",
          clearable: true,
          class: "col-12 col-md-3",
          options: this.collections.impediments,
          value: this.filters.impediment,
          disabled: this.collections.impediments?.length <= 0,
        },
        {
          name: "languageProficiency",
          component: "custom-drop-down",
          fieldKey: "id",
          fieldName: "name",
          label: "Aprendices del Español:",
          placeholder: "Seleccione",
          clearable: true,
          class: "col-12 col-md-3",
          options: this.collections.languagesProficiency,
          value: this.filters.languageProficiency,
          disabled: this.collections.languagesProficiency?.length <= 0,
        },
        {
          name: "locationAlternative",
          component: "custom-drop-down",
          fieldKey: "id",
          fieldName: "name",
          label: "Alternativa de Ubicación:",
          placeholder: "Seleccione",
          clearable: true,
          class: "col-12 col-md-3",
          options: this.collections.locationAlternatives,
          value: this.filters.locationAlternative,
          disabled: this.collections.locationAlternatives?.length <= 0,
        },
        {
          name: "studentSieId",
          label: "SIE:",
          component: "CustomInput",
          class: "col-12 col-md-3",
          value: this.filters.studentSieId,
          placeholder: "Escriba número de SIE",
          type: "number",
        },
      ];
    },
    pagingList() {
      return [
        {
          id: 20,
          name: 20,
        },
        {
          id: 40,
          name: 40,
        },
        {
          id: 60,
          name: 60,
        },
        {
          id: 80,
          name: 80,
        },
        {
          id: 100,
          name: 100,
        },
      ];
    },
    computePercentage() {
      if (
        this.summary.totalChildCount === 0 ||
        this.summary.lastYearDifferenceCount === 0
      )
        return 0;

      let difference = Math.abs(
        this.summary.lastYearDifferenceCount - this.summary.totalChildCount
      );

      let maxValue = Math.max(
        this.summary.lastYearDifferenceCount,
        this.summary.totalChildCount
      );

      return Math.floor(Math.abs((difference * 100) / maxValue));
    },
    edenDataValidationErrorTypeEnum() {
      return edenDataValidationErrorType;
    },
  },
  watch: {
    mediaQueries: {
      immediate: true,
      async handler() {
        if (this.mediaQueries.mobile) {
          this.resultData.pagination.pageSize = this.pageSizeMobile;
          this.$emit("on-search");
          return;
        }
        this.resultData.pagination.pageSize = this.pageSize;
      },
    },
  },
  async mounted() {
    //set default paging
    if (!this.resultData.selectedPaging) {
      this.resultData.selectedPaging = this.pagingList.find(
        (x) => x.id == this.pageSize
      );
    }
    await this.searchDetail();
  },
  methods: {
    async onHandlerSearch() {
      this.resultData.pagination.currentPage = 1;
      await this.searchDetail();
    },
    async goToPageHandler(page) {
      this.resultData.pagination.currentPage = page;
      await this.searchDetail();
    },
    async onSelectedPagingHandler(pageSize) {
      if (pageSize) {
        this.resultData.pagination.currentPage = 1;
        this.resultData.pagination.pageSize = pageSize;
        await this.searchDetail();
      }
    },
    async searchDetail() {
      const params = {
        edenMasterId: new Number(this.$route.params.id),
        ethnicGroupId: this.filters.ethnicGroup?.id,
        ageGroupId: this.filters.ageGroup?.id,
        genderId: this.filters.gender?.id,
        impedimentId: this.filters.impediment?.id,
        languageProficiency: this.filters.languageProficiency?.id,
        alternativeLocationId: this.filters.locationAlternative?.id,
        studentSieId:
          this.filters.studentSieId && new Number(this.filters.studentSieId),
        pageIndex: this.resultData.pagination.currentPage,
        pageSize: this.resultData.pagination.pageSize,
      };

      await Service.searchDetail(params).then(({ data }) => {
        this.resultData = {
          ...this.resultData,
          result: data.data,
          pagination: {
            ...this.resultData.pagination,
            totalItemCount: data.totalItemCount,
            pageCount: data.pageCount,
            currentPage: data.currentPage,
            count: data.count,
            pageSize: this.resultData.pagination.pageSize,
          },
        };
      });
    },
    async onGetAlertDetailReportHandler(errorTypeId) {
      await ReportServices.getReport("edenchildcountalertdetails", {
        edenMasterId: this.edenMasterId,
        errorTypeId,
      })
        .then((res) => DocumentServices.Download(res.data))
        .catch((err) => {
          this.ShowToast("", err.response?.data?.message, "error");
        });
    },
  },
};
</script>
